export type LogConfig = {
  service: string
  env: string | undefined
  version: string | undefined
}

type Env = Record<string, string | undefined>

const DEFAULT_SERVICE = 'moss-website-frontend'

export const getLogConfig = (env: Env = process.env): LogConfig => ({
  service: env.DD_SERVICE || DEFAULT_SERVICE,
  env: env.DD_ENV || env.VERCEL_ENV || (env.NODE_ENV === 'development' ? 'development' : undefined),
  version: env.DD_VERSION || env.VERCEL_GIT_COMMIT_SHA || undefined,
})
